import Vue from 'vue';
import VueRx from 'vue-rx';
import VueRouter from 'vue-router';
import './polyfill';
import {routes as ratingRoutes} from './routes/rating';
import {routes as tournamentRoutes} from './routes/tournament';
import {setupStore} from '@/store';
import {setupValidate} from '@/validate';
import 'toastr/build/toastr.min.css';
import VueDragscroll from 'vue-dragscroll';

function mountApp(elementId: string, routes: any, store: any) {
  const element = document.getElementById(elementId);
  if (element) {
    element.appendChild(
      document.createElement('router-view'),
    );
    const router = new VueRouter({routes});
    new Vue({router, store}).$mount(`#${elementId}`);
  }
}

window.addEventListener('load', () => {
  Vue.config.productionTip = false;
  Vue.use(VueRx);
  Vue.use(VueDragscroll);

  Vue.filter('lowercase', (value: any) => {
    if (!value) { return ''; }
    return value.toLowerCase();
  });

  Vue.use(VueRouter);

  const store = setupStore();
  setupValidate();

  mountApp('hw-rating', ratingRoutes, store);
  mountApp('hw-tournament', tournamentRoutes, store);
});
